import axios, { getEnv } from '../../../services/api';
import Axios from 'axios';

export const AcessosService = {
  findAll: async (params, body = {}, source) => {
    try {
      const response = await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/acessos`,
        body,
        {
          params,
          cancelToken: source?.token,
        }
      );
      return response.data;
    } catch (error) {
      if (Axios.isCancel(error)) {
        console.log('Requisição cancelada', error.message);
      } else {
        console.log(error.message);
        throw error;
      }
    }
  },

  find: async (idVersao) => {
    try {
      const response = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/atendimentos-sas/tipos/${idVersao}`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  getFilterOptions: async () => {
    try {
      const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/acessos/opcoes?consulta=true`);
      return response.data;
    } catch (error) {
      return error;
    }
  },

  searchInput: async (body, params, source) => {
    const response = await axios.post(
      `${await getEnv(
        'REACT_APP_URL_SERVICE'
      )}/v1/atendimentos-sas/tipos/consultar`,
      body,
      {
        params,
        cancelToken: source.token,
      }
    );
    source.cancel('Operação cancelada pelo usuário');
    return response.data;
  },

  consultar: async (body, params) => {
    const response = await axios.post(
      `${await getEnv(
        'REACT_APP_URL_SERVICE'
      )}/v1/atendimentos-sas/tipos/consultar?page=0&linesPerPage=10&orderBy=id&direction=ASC`,
      body,
      { params }
    );
    return response.data;
  },
};
